module.exports = __webpack_public_path__ + "static/Banner-38-114fe034f90db36856c5c374218ebaab.png";